module.exports = __webpack_public_path__ + "img/person-dolly.00122116.svg";